var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id && _vm.clientKey)?_c('div',{staticClass:"button button--full",style:(_vm.style),on:{"click":_vm.click}},[_vm._v("\n  "+_vm._s(_vm.$t('components.yandex-ticket-bue-button.title'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }